import type { TimeFrame } from "./types";
import { getTimeframeIntervalMs } from "./aggregation";

function getTzOffsetMs(): number {
  return -new Date().getTimezoneOffset() * 60_000;
}

/** Align a timestamp to the open of its OHLC bucket (local TZ, matches chart/DuckDB). */
export function alignTimestampToTimeframe(
  timestampMs: number,
  timeframe: TimeFrame,
): number {
  if (timeframe === "1m") {
    const d = new Date(timestampMs);
    d.setSeconds(0, 0);
    return d.getTime();
  }

  const intervalMs = getTimeframeIntervalMs(timeframe);
  if (intervalMs != null) {
    const tzOffset = getTzOffsetMs();
    return (
      Math.floor((timestampMs + tzOffset) / intervalMs) * intervalMs - tzOffset
    );
  }

  const date = new Date(timestampMs);
  const bucketTime = new Date(date);

  if (timeframe === "1w") {
    const dayOfWeek = date.getDay();
    const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    bucketTime.setDate(date.getDate() - daysToSubtract);
    bucketTime.setHours(0, 0, 0, 0);
  } else if (timeframe === "1mn") {
    bucketTime.setDate(1);
    bucketTime.setHours(0, 0, 0, 0);
  }

  return bucketTime.getTime();
}
